import {
  accrualPolicySchema,
  EAccrualPolicyType,
  ERolloverType,
  schemes,
  zSchema,
} from "@zeal/common";

export const createAccrualPolicyRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  policy_code: schemes.nonEmptyString("Policy code required."),
  policy_type: zSchema.nativeEnum(EAccrualPolicyType),
  policy_name: zSchema.string().optional(),
  policy_effective_date: schemes.isoDate().optional(),
  accrual_rate_hours: zSchema.number().positive(),
  accrual_period_hours: zSchema.number().positive(),
  immediate_balance: zSchema.number().nonnegative().nullish(),
  include_doubletime: zSchema.boolean(),
  include_overtime: zSchema.boolean(),
  include_flat: zSchema.boolean().nullish(),
  accrual_waiting_period: zSchema.number().nonnegative().nullish(),
  accrual_start_after_days: zSchema.number().int().nonnegative().nullish(),
  accrual_cap: zSchema.number().nonnegative().nullish(),
  rollover_cap: zSchema.number().nullish(),
  rollover_date: zSchema.string().nullish(),
  rollover_type: zSchema.nativeEnum(ERolloverType).nullish(),
  balance_cap: zSchema.number().nonnegative().nullish(),
  workers: zSchema.array(schemes.mongoObjectId()).default([]),
});

export type TCreateAccrualPolicyRequestSchema = zSchema.infer<
  typeof createAccrualPolicyRequestSchema
>;

export const createAccrualPolicyResponseSchema = accrualPolicySchema;

export type TCreateAccrualPolicyResponseSchema = zSchema.infer<
  typeof createAccrualPolicyResponseSchema
>;
